import { HttpParams } from '@angular/common/http'
import { Component, OnDestroy, OnInit, effect, inject, input } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { CellType, GridPanel } from '@grapecity/wijmo.grid'
import { QuillViewComponent } from 'ngx-quill'
import { Subscription } from 'rxjs'
import { DeviceNotificationService } from 'src/app/shared/services/device-notification-service'

import { AuthenticationService, BaseComponent, Grid, NotificationInstance } from '../../shared'
import { DateUtil } from '../../shared/utility/date'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'

@Component({
    selector: 'app-home-notifications',
    templateUrl: './notifications.component.html',
    standalone: true,
    imports: [FormsModule, ActionToolbarCount, ActionToolbarSearchComponent, WjGridModule, WjGridFilterModule, QuillViewComponent],
})
export class HomeNotificationsComponent extends BaseComponent implements OnInit, OnDestroy {
    faSearch = faSearch

    private authService = inject(AuthenticationService)
    private deviceNotificationService = inject(DeviceNotificationService)

    grid: Grid<NotificationInstance>
    instanceId = input<string | undefined>(undefined)

    private sub = new Subscription()

    constructor() {
        super()

        effect(() => {
            if (this.instanceId()) {
                this.markAsViewed(this.instanceId() as string, this.authService.userId())
            }

            if (this.authService.userId()) {
                this.refresh()
            }
        })

        this.grid = new Grid<NotificationInstance>(this.services).filterBy(item => [item.title]).doInitialSelection(false)
        this.refresh()
    }

    ngOnInit(): void {
        this.sub.add(
            this.deviceNotificationService.currentmessage$.pipe().subscribe(message => {
                if (message) setTimeout(() => this.refresh(), 750)
            }),
        )
    }

    ngOnDestroy(): void {
        this.sub.unsubscribe()
    }

    refresh() {
        const params = new HttpParams().append('userId', this.authService.userId())
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(true, true, this.services.data.notificationInstances.queryAllByAction('GetByUserId', params))
                .subscribe({
                    next: result => {
                        this.grid.items = result[0].orderByDescending(x => DateUtil.toTimestamp(x.sentDate))
                        this.grid.selectedItem = this.grid.view.items[0]
                        this.grid.view.refresh()
                    },
                }),
        )
    }

    itemFormatter = (panel: GridPanel, r, c, cell: HTMLDivElement) => {
        if (panel.cellType === CellType.Cell) {
            const row = panel.grid.rows[r]
            const rowItem = row.dataItem as NotificationInstance

            cell.style.fontWeight = 'unset'
            if (!rowItem.viewed) {
                cell.style.fontWeight = '750'
            }
        }
    }

    onSelectionChange() {
        if (!this.grid.selectedItem || this.grid.selectedItem.viewed) return
        this.grid.selectedItem.viewed = true
        this.markAsViewed(this.grid.selectedItem.id, this.authService.userId())
    }

    markAsViewed(instanceId: string, userId: string) {
        const params = new HttpParams().append('instanceId', instanceId).append('userId', userId)
        this.grid.view.refresh()
        this.services.data.load(false, false, this.services.data.get('/api/NotificationInstance/MarkedAsViewd', params)).subscribe({
            next: result => console.log('Marked as viewed', result),
        })
    }
}
